import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IGetSearchedInterventionResponseList } from 'services/httpClient/responses/intervention/IGetSearchedInterventionResponse';

import { IInterventionData } from '../../initialState';

export interface IGetSearchedInterventionSuccessWithDataAction {
  list: IGetSearchedInterventionResponseList[];
}

function getSearchedInterventionSuccessWithData(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetSearchedInterventionSuccessWithDataAction>,
) {
  draft.getSearchedIntervention.list = action.payload.list;
  draft.getSearchedIntervention.config.isLoading = false;
}

export default getSearchedInterventionSuccessWithData;
